<template>
  <v-text-field
    ref="passwordField"
    :value="value"
    v-bind="$attrs"
    :append-icon="appendIcon"
    :type="inputType"
    :rules="rules"
    @input="$emit('input', $event)"
    @blur="onBlur"
    @click:append="show = !show"
  />
</template>

<script>
export default {
  name: 'PasswordField',
  props: {
    value: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: () => []
    },
    hideIcon: {
      type: String,
      default: 'mdi-eye-off'
    },
    showIcon: {
      type: String,
      default: 'mdi-eye'
    }
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    inputType () {
      return this.show ? 'text' : 'password'
    },
    appendIcon () {
      return this.show ? this.hideIcon : this.showIcon
    }
  },
  methods: {
    async onBlur () {
      await this.$nextTick()
      this.$emit('blur')
    }
  }
}
</script>
